/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

const SectionStatusSteps = {
    not_started: { label: 'Not Started', index: 0 },
    content_mapping: { label: 'Content Mapping', index: 1 },
    alpha_development : { label: 'Alpha Development', index: 2 },
    alpha_internal_review: { label: 'QA - Alpha Internal Review', index: 3 },
    alpha_review: { label: 'Alpha Review', index: 4 },
    alpha_revisions: { label: 'Alpha Revisions', index: 5 },
    beta_internal_review: { label: 'QA - Beta Internal Review', index: 6 },
    beta_review: { label: 'Beta Review', index: 7 },
    beta_revisions: { label: 'Beta Revisions', index: 8 },
    final_internal_review: { label: 'QA - Final Internal Review', index: 9 },
    final_review: { label: 'Final Review', index: 10 },
    complete: { label: 'Complete', index: 11 }
}

export default SectionStatusSteps;